
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lt/sub/hostingas",
      function () {
        return require("private-next-pages/lt/sub/hostingas.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lt/sub/hostingas"])
      });
    }
  